import { FC, ReactNode, MouseEventHandler } from 'react';
import { motion } from "framer-motion";

import './Backdrop.scss';

type BackdropProps  = {
  onClick: () => void;
  children?: ReactNode | ReactNode[];
}

const stopPropagation: MouseEventHandler<HTMLDivElement> = e => {
  e.persist();
  e.stopPropagation();
};

const Backdrop: FC<BackdropProps> = ({ onClick, children }:BackdropProps) => {

  return (
    <motion.div
      onClick={onClick}
      className="backdrop"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div onClick={stopPropagation}>{children}</div>
    </motion.div>
  );
};

export default Backdrop;
